export const PLAYBOOKS_CHAT_DIMENSIONS = {
  PLAYBOOK_ID: 'DriftChatPlaybooks.playbookId',
  PLAYBOOK_NAME: 'DriftChatPlaybooks.name',
  PLAYBOOK_STATUS: 'DriftChatPlaybooks.status',
  PLAYBOOK_CREATED_AT: 'DriftChatPlaybooks.createdAt',
  PLAYBOOK_REPORT_TYPE: 'DriftChatPlaybooks.reportType',
  PLAYBOOK_WORKSPACE_ID: 'DriftChatPlaybooks.workspaceId',
  PLAYBOOK_IS_AI_ENABLED: 'DriftChatPlaybooks.isAiEnabled',
}

export const DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES = {
  COUNT_IMPRESSIONS: 'DriftChatBlendedPlaybookMetrics.countImpressions',
  COUNT_SENDS: 'DriftChatBlendedPlaybookMetrics.countSends',
  COUNT_CONVERSATIONS: 'DriftChatBlendedPlaybookMetrics.countConversations',
  COUNT_EMAILS_CAPTURED: 'DriftChatBlendedPlaybookMetrics.countEmailsCaptured',
  COUNT_MEETINGS_BOOKED: 'DriftChatBlendedPlaybookMetrics.countMeetingsBooked',
  AVG_CQL_SCORE: 'DriftChatBlendedPlaybookMetrics.avgCQLScore',
}

export const DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS = {
  PLAYBOOK_ID: 'DriftChatBlendedPlaybookMetrics.playbookId',
  PLAYBOOK_VERSION: 'DriftChatBlendedPlaybookMetrics.playbookVersion',
  METRIC_AT: 'DriftChatBlendedPlaybookMetrics.metricAt',
  BOT_FLOW: 'DriftChatBlendedPlaybookMetrics.botFlow',
}
